import React from "react";
import { Link } from "react-router-dom";

export default function PrintLink(props) {
  let is_printable = false;
  if (props.isStudent === true) {
    Object.keys(props.userAssessment.scoring.bySubtest).map(function(value) {
      let is_complete = props.userAssessment.scoring.bySubtest[value].complete;
      if (is_complete === true) {
        is_printable = true;
      }
    });
  } else {
    
   if(props.groupUA !== null && props.groupUA.scoring && props.groupUA.scoring.bySubtest){
    Object.keys(props.groupUA.scoring.bySubtest).map(function(value) {
      let is_complete = props.groupUA.scoring.bySubtest[value].complete;
      if (is_complete === true) {
        is_printable = true;
      }
    });
    }
  }
  return (
    <p className="float-right">
      {is_printable ? <i className="icon-note icons font-1xl" /> : null}{" "}
      {is_printable ? <Link to={props.printPath}>Export to PDF</Link> : null}
    </p>
  );
}



// WEBPACK FOOTER //
// ./src/components/Assessment/PrintLink.js